import { GridColDef } from "@mui/x-data-grid-pro";
import { postContestStackDataGridHeaderConfig, postContestStackTypeDataGridHeaderConfig } from "../common/Table/PostContestConfig";
import { stackDataNFLGridHeaderConfig } from "../common/Table/newTableConfig";
import { ContestApiResponse } from "../postContest/queries/queryTypes";
import { SlateResponse } from "../common/store/types";
import { ContestStacks, StackConstraint } from "../contestGenerator/store/types";

export const stackSports = ['mlb', 'nfl', 'mma', 'cfb'];


export const showStackPostContest = (slate: ContestApiResponse | SlateResponse): boolean => {
    switch (slate?.sport?.toUpperCase()) {
        case 'MLB':
            return true;
        case 'NFL':
            return slate?.type?.toUpperCase() !== 'SHOWDOWN'
        case 'CFB':
            return slate?.type?.toUpperCase() !== 'SHOWDOWN'
        default:
            return false;
    }
}

export const showStackColumnsPreContest = (slate: ContestApiResponse | SlateResponse): boolean => {
    switch (slate?.sport?.toUpperCase()) {
        case 'MLB':
            return slate?.type?.toUpperCase() !== 'SHOWDOWN';
        case 'NFL':
            return slate?.type?.toUpperCase() !== 'SHOWDOWN'
        case 'CFB':
            return slate?.type?.toUpperCase() !== 'SHOWDOWN'
        default:
            return false;
    }
}

export const showStackTabsPreContest = (slate:ContestApiResponse | SlateResponse): boolean => {
    switch (slate?.sport?.toUpperCase()) {
        case 'MLB':
            return slate?.type?.toUpperCase() !== 'SHOWDOWN';
        case 'NFL':
            return slate?.type?.toUpperCase() !== 'SHOWDOWN'
        case 'CFB':
            return slate?.type?.toUpperCase() !== 'SHOWDOWN'
        default:
            return false;
    }
}

export const isStackType = (stacks: ContestStacks, constraint: StackConstraint, sport: string): boolean  => {
    if (sport.toLowerCase() === 'mlb') {
        return stacks.stackType.includes(constraint.primary === 0 ? "None" : `${constraint.primary}-${constraint.secondary === 0 ? 'x' : constraint.secondary}`)
    }
    return stacks.stackType.includes('QB + ' + constraint.primary)
}

export const showStackExposuresPreContest = (slate:ContestApiResponse | SlateResponse): boolean => {
    switch (slate?.sport?.toUpperCase()) {
        case 'MLB':
            return slate?.type?.toUpperCase() !== 'SHOWDOWN';
        case 'NFL':
            return slate?.type?.toUpperCase() !== 'SHOWDOWN'
        case 'CFB':
            return slate?.type?.toUpperCase() !== 'SHOWDOWN'
        default:
            return false;
    }
}
export const showStackContestGen = (slate: SlateResponse | ContestApiResponse): boolean => {
    return stackSports.includes(slate?.sport?.toLowerCase())
}

export const showStackTabContestGen = (slate: SlateResponse | ContestApiResponse): boolean => {
    return stackSports.includes(slate?.sport?.toLowerCase()) && slate?.sport?.toUpperCase() !== 'MMA'
}


export const getPostContestStackTableConfig = (slate: SlateResponse | ContestApiResponse, stackType: string): GridColDef[] => {
    switch (slate?.sport?.toUpperCase()) {
        case 'MLB':
            return stackType === 'playerExp' ? postContestStackDataGridHeaderConfig  : postContestStackTypeDataGridHeaderConfig;
        case 'NFL':
            return stackDataNFLGridHeaderConfig;
        default:
            return stackDataNFLGridHeaderConfig;
    }
}